import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID
} from '@angular/core';
import {distinctUntilChanged, filter, take} from "rxjs/operators";
import {selectCustomer} from "@store/actions/storage.action";
import {AppState} from "@store/state/app.state";
import {Store} from "@ngrx/store";
import {ConfigService} from "@iw-shop/config/service/config.service";
import {ChangeTimezone} from "@iw-shop/core/functions/date";
import {Observable, Subject, takeUntil} from "rxjs";
import {GoogleTagManagerService} from "@iw-shop/google-tag-manager/services/google-tag-manager.service";
import {Customer} from "@iw-shop/customer/models/customer";
import {MappedCustomer} from "@store/state/user.state";
import {getMappedCustomer, getSelectedCustomer} from "@store/selectors/user.selector";
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";
import {AsyncPipe, isPlatformBrowser, NgForOf, NgIf} from "@angular/common";
import {CoreModule} from "@iw-shop/core/core.module";
import {LayoutModule} from "@_basic/layout/layout.module";
import {NewsModule} from "@iw-shop/news/news.module";
import {DynamicArticleModule} from "@iw-shop/dynamic-article/dynamic-article.module";
import {ReactiveFormsModule} from "@angular/forms";
import {MyFormsModule} from "@iw-shop/forms/my-forms.module";
import {UserModule} from "@iw-shop/user/user.module";
import {CustomerModule} from "@iw-shop/customer/customer.module";
import {SubLayoutModule} from "@shop_allgaeu-brennerei_de/layout/sub-layout.module";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CoreModule, LayoutModule, NewsModule, AsyncPipe, DynamicArticleModule, ReactiveFormsModule,  MyFormsModule, UserModule, CustomerModule, NgIf,  NgForOf, SubLayoutModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly isBrowser: boolean;

    destroy$: Subject<boolean> = new Subject<boolean>();

    userMappedCustomers$?: Observable<Customer[] | undefined>;
    selectedCustomer$: Observable<MappedCustomer | undefined>;

    constructor(
        private router: Router,
        private configService: ConfigService,
        private titleService: Title,
        private meta: Meta,
        private store: Store<AppState>,
        @Inject(PLATFORM_ID) platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.selectedCustomer$ = this.store.select(getSelectedCustomer);
        this.userMappedCustomers$ = this.store.select(getMappedCustomer);
        if (this.isBrowser) {
            this.store.select(state => state.config)
                .pipe(take(1))
                .subscribe(
                    r => {

                        let date = ChangeTimezone(new Date(r.lastUpdate), 'Europe/Berlin');

                        let styles = document.createElement('link'); // creates the script tag
                        styles.href = './api/' + date.getFullYear() + date.getMonth() + date.getDate() + '-' + date.getHours() + date.getMinutes() + date.getSeconds() + '-dynamic.css'; // sets the source (insert url in between quotes)
                        styles.rel = 'stylesheet'; // set the script type
                        styles.type = 'text/css';
                        styles.media = 'screen';
                        // append to head of document
                        document.getElementsByTagName('head')[0].appendChild(styles);

                        let js = document.createElement('script'); // creates the script tag
                        js.src = './api/' + date.getFullYear() + date.getMonth() + date.getDate() + '-' + date.getHours() + date.getMinutes() + date.getSeconds() + '-dynamic.js'; // sets the source (insert url in between quotes)
                        js.type = 'text/javascript'; // set the script type
                        js.async = true; // makes script run asynchronously
                        // append to head of document
                        document.getElementsByTagName('head')[0].appendChild(js);


                    }
                )
        }
    }

    setSEO() {
        this.store.select(state => state.global.SEO)
            .pipe(
                take(1)
            )
            .subscribe(
                r => {
                    let SEO: {
                        title: string;
                        description: string;
                        keywords: string;
                        useForUrl: string;
                    } = {title: '', description: '', keywords: '', useForUrl: ''};
                    if (this.router.routerState.snapshot.url == r?.useForUrl) {
                        SEO = r;
                    }
                    const SEODefault = this.configService.getSEO('default');

                    if (SEO.title.length > 0) {
                        this.titleService.setTitle(SEO.title);
                    } else {
                        this.titleService.setTitle(SEODefault.title);
                    }
                    if (SEO.description.length > 0) {
                        this.meta.updateTag({name: 'description', content: SEO.description});
                    } else {
                        this.meta.updateTag({name: 'description', content: SEODefault.description});
                    }
                    if (SEO.keywords.length > 0) {
                        this.meta.updateTag({name: 'keywords', content: SEO.keywords});
                    } else {
                        this.meta.updateTag({name: 'keywords', content: SEODefault.keywords});
                    }
                });
    }

    ngOnInit() {

        this.router.events
            .pipe(
                takeUntil(this.destroy$),
                filter((event) => event instanceof NavigationEnd)
            )
            .subscribe(() => {
                    this.setSEO();
                }
            );

        this.store.select(state => state.global.SEO)
            .pipe(
                takeUntil(this.destroy$),
                distinctUntilChanged()
            )
            .subscribe(
                r => {
                    this.setSEO();
                }
            )


    }

    selectCustomer(customerId: string) {
        this.store.dispatch(selectCustomer({customerId}));
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
